import { MedicalInformationType } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { Message, MessageType, Modal, ModalMaxHeight, ModalWidth, StyledFlex } from '@dreryk/react-components';

import { patientMedicalInformationTranslationKeys } from '../../translations';

import { MedicalInformationFormRenderer, MedicalInformationTypeSelector } from './MedicalInformationTypeSelector';

type MedicalInformationAddEntryModalProps = {
   readonly availableMedicalInformationTypes: MedicalInformationType[] | undefined;
   readonly patientId: number;
   readonly onClose: VoidFunction;
   readonly children: MedicalInformationFormRenderer;
};

export const MedicalInformationAddEntryModal = (props: MedicalInformationAddEntryModalProps): JSX.Element => {
   return (
      <Modal
         testId={'createMedicalInformationEntry'}
         title={patientMedicalInformationTranslationKeys.addEntry}
         visible
         animateVisibility
         width={ModalWidth.NORMAL}
         height={ModalMaxHeight.FULL}
      >
         <StyledFlex direction={'column'} gap={'24px'}>
            <Message
               type={MessageType.WARNING}
               fullWidth
               displayIndicator
               label={patientMedicalInformationTranslationKeys.addEntryModal.youCannotEditEntry}
               testId={'status'}
            />
            <MedicalInformationTypeSelector
               patientId={props.patientId}
               onClose={props.onClose}
               availableMedicalInformationTypes={props.availableMedicalInformationTypes}
            >
               {props.children}
            </MedicalInformationTypeSelector>
         </StyledFlex>
      </Modal>
   );
};
